import { type DomainAccessControlConfig } from '../utils/domain/accessControl'

export const massopsAccessControl: DomainAccessControlConfig = {}
